package com.downdogapp.client.views.start

import com.downdogapp.*
import com.downdogapp.AlignItems.CENTER
import com.downdogapp.Position.ABSOLUTE
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.View
import com.downdogapp.client.controllers.start.Page
import com.downdogapp.client.controllers.start.StartViewController
import com.downdogapp.client.widget.*
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLSpanElement
import kotlin.contracts.ExperimentalContracts
import kotlin.contracts.InvocationKind.EXACTLY_ONCE
import kotlin.contracts.contract

actual class StartView : TopLevelView(), View {

  actual fun goToPage(page: Page) {
    page.refreshPage()
    fg?.setSelectedPage(page)
  }

  override val root =
    controllerView {
      bg = background(true)
      fg = foreground(true)
      goToPage(StartViewController.selectedPage)
    }

  companion object {

    val TITLE_TOP_MARGIN_PX = px(80)
    val CONTENT_TOP_MARGIN_PX = px(145)
    val TITLE_FONT_SIZE = 28
  }

  actual fun setTabBarOpacity(value: Number) {}
  actual fun hideLoadingOverlay() {}
}

fun HTMLElement.startPageTitle(): HTMLSpanElement {
  div {
    position = ABSOLUTE
    top = StartView.TITLE_TOP_MARGIN_PX
    width = percent(100)

    verticalFlexBox(horizontalAlign = CENTER) {
      return label(fontSize = StartView.TITLE_FONT_SIZE)
    }
  }
}

@OptIn(ExperimentalContracts::class)
fun HTMLElement.startPageContent(width: Size? = CENTERED_COLUMN_WIDTH_PX,
                                 block: HTMLDivElement.() -> Unit): HTMLDivElement {
  contract {
    callsInPlace(block, EXACTLY_ONCE)
  }
  return topOffsetDiv(top = StartView.CONTENT_TOP_MARGIN_PX) {
    marginBottom = px(40)

    div {
      width?.let {
        this.width = it
      }

      block()
    }
  }
}
